import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { routes } from "../../constants/routes";
import { injectModels } from "../../redux/injectModels";
import { EventService } from "../../services";
import RolePermission from "../../services/RolePermission";
import { EventActionType, AccountActionType } from "../../constants/Enum";
import { AuthService } from "../../services";

const ReportDashboard = ({ children }) => {
  const loginUser = AuthService.getLoginUser();
  // const [selectedEvent, setSelectedEvent] = useState(
  //   EventService.getSelectedEvent()
  // );

  useEffect(() => {
    // const c = EventService.getSelectedEvent();
    // setSelectedEvent(c);
  }, []);
  return (
    <React.Fragment>
      <section className="edit-form-table mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-2">
              <aside>
                <ul className="list-unstyled ps-0 sidemenu">
                  <li className="mb-1">
                    <button
                      className="btn btn-toggle-nw align-items-center "
                      data-bs-toggle="collapse"
                      data-bs-target="#reportData-collapse"
                      aria-expanded="true"
                    >
                      Reports
                    </button>
                    <div
                      className="collapse submenu show"
                      id="reportData-collapse"
                    >
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        {RolePermission.isAccess(
                          loginUser?.role,
                          EventActionType.FeedBack
                        ) ? (
                          <li>
                            <Link
                              to={routes.EVENT_FEEDBACK_REPORTS}
                              className="link-dark "
                            >
                              Scores on the Floors
                            </Link>
                          </li>
                        ) : (
                          <></>
                        )}
                        {RolePermission.isAccess(
                          loginUser?.role,
                          EventActionType.EoFinansialReport
                        ) ? (
                          <li>
                            <Link
                              to={routes.EVENT_TRANSACTION_REPORTS}
                              className="link-dark "
                            >
                              Application Transactions
                            </Link>
                          </li>
                        ) : (
                          <></>
                        )}

                        {RolePermission.isAccess(
                          loginUser?.role,
                          EventActionType.EoFinansialReport
                        ) ? (
                          <li>
                            <Link
                              to={routes.EVENT_PITCH_SALE_REPORTS}
                              className="link-dark "
                            >
                              Sales Summary
                            </Link>
                          </li>
                        ) : (
                          <></>
                        )}

                        {RolePermission.isAccess(
                          loginUser?.role,
                          AccountActionType.TraderReport
                        ) ? (
                          <li>
                            <Link
                              to={routes.EVENT_TRADER_REPORTS}
                              className="link-dark "
                            >
                              Application Transactions
                            </Link>
                          </li>
                        ) : (
                          <></>
                        )}

                        {RolePermission.isAccess(
                          loginUser?.role,
                          EventActionType.TicketFinansialReports
                        ) ? (
                          <li>
                            <Link
                              to={routes.EVENT_TICKET_TRANSACTION_REPORTS}
                              className="link-dark "
                            >
                              Ticket Transactions
                            </Link>
                          </li>
                        ) : (
                          <></>
                        )}
                      </ul>
                    </div>
                  </li>
                </ul>
              </aside>
            </div>
            <div className="col-md-10">{children}</div>
          </div>

          <div></div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(ReportDashboard);
